import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const SCRIPT_SRC = 'https://www.vlibras.gov.br/app/vlibras-plugin.js';
const WIDGET_SRC = 'https://www.vlibras.gov.br/app';
const SCRIPT_ATTR = 'data-pai-vlibras';

/**
 * VLibras opcional — só após o boot do Portal
 * (configuracaoaparencia + cliente + MenuPortal).
 * Falha do vlibras.gov.br não trava a página.
 */
function VLibrasWidget() {
  const portalBootReady = useSelector(
    state => state.configuration.portalBootReady
  );
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (portalBootReady) {
      setEnabled(true);
    }
  }, [portalBootReady]);

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;
    let initId;

    const initPlugin = () => {
      if (cancelled) return;
      if (!window.VLibras || typeof window.VLibras.Widget !== 'function') {
        return;
      }
      initId = window.setTimeout(() => {
        if (cancelled) return;
        try {
          // eslint-disable-next-line no-new
          new window.VLibras.Widget(WIDGET_SRC);
          if (typeof window.onload === 'function') {
            window.setTimeout(() => {
              try {
                if (!cancelled && typeof window.onload === 'function') {
                  window.onload(new Event('load'));
                }
              } catch (err) {
                // eslint-disable-next-line no-console
                console.warn('[VLibras] onload opcional falhou', err);
              }
            }, 0);
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.warn('[VLibras] init opcional falhou', err);
        }
      }, 0);
    };

    if (document.querySelector(`script[${SCRIPT_ATTR}]`)) {
      initPlugin();
      return () => {
        cancelled = true;
        window.clearTimeout(initId);
      };
    }

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.setAttribute(SCRIPT_ATTR, '1');
    script.onload = initPlugin;
    script.onerror = () => {
      // eslint-disable-next-line no-console
      console.warn('[VLibras] indisponível (opcional) — Portal segue normal');
    };
    document.body.appendChild(script);

    return () => {
      cancelled = true;
      window.clearTimeout(initId);
    };
  }, [enabled]);

  if (!enabled) {
    return null;
  }

  return (
    <aside aria-label="Tradutor VLibras para Libras">
      <div vw="true" className="enabled">
        <div vw-access-button="true" className="active" />
        <div vw-plugin-wrapper="true">
          <div className="vw-plugin-top-wrapper" />
        </div>
      </div>
    </aside>
  );
}

export default VLibrasWidget;
